import { useMatomo } from '@datapunt/matomo-tracker-react/lib';
import ReactGA, { EventArgs } from 'react-ga';
import { isGaEnabled } from './initGA';
import { isMatomoEnabled } from './initMatomo';

interface MatomoEvent {
	category: string;
	action: string;
	name?: string;
	value?: number | undefined;
}

const toMatomoEvent = (gaEventData: EventArgs): MatomoEvent => ({
	category: gaEventData.category,
	action: gaEventData.action,
	name: gaEventData.label,
	value: gaEventData.value,
});

/**
 * Custom hook that provides universal tracking functions for all tracking providers
 */
export function useUniversalTracking(): {
	trackEvent(eventData: EventArgs): void;
	trackPageView(page: string): void;
} {
	const { trackEvent } = useMatomo();
	const { trackPageView } = useMatomo();

	return {
		trackEvent: (eventData: EventArgs) => {
			// console.log('track event', eventData);
			//TODO: activate if enable MATOMO
			// if (isMatomoEnabled()) {
			// 	trackEvent(toMatomoEvent(eventData));
			// }
			if (isGaEnabled()) {
				ReactGA.event(eventData);
			}
		},
		trackPageView: (page: string) => {
			// console.log('track page view', page);
			//TODO: activate if enable MATOMO
			// if (isMatomoEnabled()) {
			// 	trackPageView({ href: page });
			// }
			if (isGaEnabled()) {
				ReactGA.pageview(page);
			}
		},
	};
}
